var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/react/index.ts
import { useMemo, useState, useCallback } from "react";

// src/index.ts
var TomoTypeahead = class {
  constructor(config) {
    this.requests = /* @__PURE__ */ new Map();
    this.displaySets = /* @__PURE__ */ new Map();
    this.currentQuery = "";
    this.debounce = 150;
    this.displaySetLimit = 5;
    this.minimumQueryLength = 2;
    var _a, _b, _c, _d;
    this.fetcher = config.fetcher;
    this.keyExtractor = config.keyExtractor;
    this.matchStringExtractor = config.matchStringExtractor;
    this.debounce = (_a = config.debounce) != null ? _a : this.debounce;
    this.displaySetLimit = (_b = config.displaySetLimit) != null ? _b : this.displaySetLimit;
    this.minimumQueryLength = (_c = config.minimumQueryLength) != null ? _c : this.minimumQueryLength;
    this.onLoadingChange = config.onLoadingChange;
    this.onDataChange = config.onDataChange;
    if (config.nullstateFetcher != null) {
      console.log("nullstateFetcher");
      this.requests.set(
        "",
        (_d = config.nullstateFetcher) == null ? void 0 : _d.call(config).then((data) => {
          const displaySet = /* @__PURE__ */ new Map();
          this.displaySets.set("", displaySet);
          this.appendToDisplaySet(displaySet, data, this.currentQuery === "");
        })
      );
    }
  }
  matchesQuery(item, query) {
    const matchString = this.matchStringExtractor(item).toLocaleLowerCase();
    return matchString.startsWith(query) || matchString.indexOf(` ${query}`) > -1;
  }
  longestCommonPrefix(query, map) {
    const key = Array.from(map.keys()).filter((key2) => query.startsWith(key2)).sort((a, b) => a.length - b.length).pop();
    if (key != null) {
      return map.get(key);
    }
  }
  setQuery(q) {
    var _a, _b, _c, _d, _e, _f, _g;
    const query = q.toLocaleLowerCase();
    if (query === this.currentQuery) {
      return;
    }
    if (!query && !this.requests.has("")) {
      this.displaySets.clear();
      this.requests.clear();
      (_a = this.onLoadingChange) == null ? void 0 : _a.call(this, false);
      (_b = this.onDataChange) == null ? void 0 : _b.call(this, []);
      return;
    }
    let displaySet;
    if (this.displaySets.has(query)) {
      displaySet = (_c = this.displaySets.get(query)) != null ? _c : /* @__PURE__ */ new Map();
      (_e = this.onDataChange) == null ? void 0 : _e.call(this, Array.from((_d = displaySet.values()) != null ? _d : []));
    } else {
      displaySet = /* @__PURE__ */ new Map();
      const longestCommonPrefixDisplaySet = this.longestCommonPrefix(
        query,
        this.displaySets
      );
      if (longestCommonPrefixDisplaySet != null) {
        const matchesFromPreviousSet = Array.from(
          (_f = longestCommonPrefixDisplaySet == null ? void 0 : longestCommonPrefixDisplaySet.values()) != null ? _f : []
        ).filter((item) => this.matchesQuery(item, query));
        this.appendToDisplaySet(displaySet, matchesFromPreviousSet, true);
      }
    }
    this.currentQuery = query;
    this.displaySets.set(query, displaySet);
    const longestCommonPrefixRequest = this.longestCommonPrefix(
      query,
      this.requests
    );
    if (query.length < this.minimumQueryLength || // request is already in flight
    this.requests.has(query) || // we already have enough local results
    displaySet.size >= this.displaySetLimit || // LCP request already entirely included, nothing more to fetch
    Array.isArray(longestCommonPrefixRequest) && longestCommonPrefixRequest.every(
      (r) => displaySet.has(this.keyExtractor(r))
    )) {
      (_g = this.onLoadingChange) == null ? void 0 : _g.call(this, false);
      return;
    }
    const req = () => __async(this, null, function* () {
      var _a2;
      (_a2 = this.onLoadingChange) == null ? void 0 : _a2.call(this, true);
      yield new Promise((r) => setTimeout(r, this.debounce));
      if (this.currentQuery !== query) {
        return;
      }
      const data = yield this.fetcher(query);
      this.appendToDisplaySet(
        displaySet,
        data,
        // do not trigger an update if it's not the current display set
        this.currentQuery === query
      );
      return data;
    });
    this.requests.set(
      query,
      req().then((data) => {
        if (data != null) {
          this.requests.set(query, data);
        } else {
          this.requests.delete(query);
        }
      }).catch((e) => {
        this.requests.delete(query);
      }).finally(() => {
        var _a2;
        if (this.currentQuery === query) {
          (_a2 = this.onLoadingChange) == null ? void 0 : _a2.call(this, false);
        }
      })
    );
  }
  appendToDisplaySet(displaySet, data, triggerUpdate) {
    var _a;
    for (const item of data) {
      const key = this.keyExtractor(item);
      if (!displaySet.has(key)) {
        displaySet.set(key, item);
      }
    }
    if (triggerUpdate) {
      (_a = this.onDataChange) == null ? void 0 : _a.call(this, Array.from(displaySet.values()));
    }
  }
};

// src/react/index.ts
function useTypeahead(config) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const typeahead = useMemo(
    () => new TomoTypeahead(__spreadProps(__spreadValues({}, config), {
      onDataChange: (data2) => {
        setData(data2);
        if ((config == null ? void 0 : config.onDataChange) != null) {
          config == null ? void 0 : config.onDataChange(data2);
        }
      },
      onLoadingChange: (loading2) => {
        setLoading(loading2);
        if ((config == null ? void 0 : config.onLoadingChange) != null) {
          config == null ? void 0 : config.onLoadingChange(loading2);
        }
      }
    })),
    []
    // ignoring config here because we don't want to recreate the typeahead
  );
  const setQuery = useCallback(
    (q) => typeahead.setQuery(q),
    [typeahead]
  );
  return {
    loading,
    data,
    setQuery
  };
}
export {
  useTypeahead
};
//# sourceMappingURL=index.js.map